




















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import LazyImage from '@/componentsV2/atoms/LazyImage/LazyImage.vue';
import OfferImageUpload from '@/componentsV2/molecules/Inputs/OfferImageUpload.vue';
import { ILocation } from '@/models/location';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import Loading from '@/components/icons/Loading.vue';
import PinIcon from '@/components/icons/PinV2.vue';
import InfoIcon from '@/components/icons/Info.vue';
import InviteMerchantSignupService from '@/api/InviteMerchantSignupService';
import EmptyImageIcon from '@/components/icons/EmptyImage.vue';
import SpecialCoinIcon from '@/components/icons/SpecialCoin.vue';

import eventBus from '@/utils/eventBus';
import { pluralize } from '@/utils';
import segmentIo from '@/utils/segment.io';

import {
  getRenewedLabel,
  getMaxRedmeedLabel,
  getExpirationDateLabel,
  EOfferRulesName,
  IOfferEdit
} from '@/models/offer';
import flagKeys from '@/constants/flagKeys';
import OfferTypeTag from '@/components/molecules/OfferTypeTag/OfferTypeTag.vue';

interface IOfferImage {
  id: string;
  url: string;
}

@Component({
  components: {
    Typography,
    LazyImage,
    OfferImageUpload,
    Loading,
    PinIcon,
    InfoIcon,
    EmptyImageIcon,
    SpecialCoinIcon,
    OfferTypeTag
  }
})
export default class Offers extends Vue {
  @Prop({ default: () => [] }) offers!: IOfferEdit[];
  @Prop() locations!: ILocation[];
  @Prop() code!: string;
  @Prop() businessId!: string;
  @Prop() businessData!: any;
  @Prop({ default: false }) offerWithoutLocation?: boolean;

  inviteMerchantSignupService = new InviteMerchantSignupService();

  uploadImageLoading: string | boolean = false;

  selectedOfferIndex: number | undefined;

  get sessionData() {
    return JSON.parse(String(sessionStorage.getItem('business-image')));
  }

  get offersTag() {
    return `${this.offers.length} ${pluralize(this.offers.length, 'Offer')}`;
  }

  get isEmpty() {
    return !this.offers.length;
  }

  get emptyStateImageSrc() {
    return require(`@/assets/img/image-placeholder.png`);
  }

  get offersWithoutImage() {
    return this.offers.filter((offer: IOfferEdit) => !offer.image).length;
  }

  maxRedmeedByRules(offer: IOfferEdit) {
    return getMaxRedmeedLabel(
      offer.rules.filter(
        (rule: any) => rule.name === EOfferRulesName.SUPPLY_RULE
      )[0]
    );
  }

  expirationDateLabel(offer: IOfferEdit) {
    return getExpirationDateLabel(offer.expirationDate);
  }

  renewedByRules(offer: IOfferEdit) {
    return getRenewedLabel(
      offer.rules.filter(
        (rule: any) => rule.name === EOfferRulesName.RENEWED_RULE
      )[0]
    );
  }

  locationsMap(locations: ILocation[]) {
    return locations.map(location => `📍 ${location.name}`).toString();
  }

  formattedFormData() {
    return this.offers.map(offer => {
      if (!offer.image) {
        return {
          ...offer,
          image: {
            id: '',
            url: ''
          }
        };
      }

      return offer;
    });
  }

  handleEndUpload(data: {
    success: boolean;
    offerId: string;
    image: IOfferImage;
  }) {
    if (!data.success) return;

    this.handleImageUpload({
      imageId: data.image.id,
      offerId: data.offerId
    });
  }

  async handleImageUpload(data: { imageId: string; offerId: string }) {
    const { status } = await this.inviteMerchantSignupService.updateOffer(
      this.code,
      data.offerId,
      {
        imageId: data.imageId
      }
    );

    if (status !== 200) return;

    eventBus.$emit('reloadInviteBusinessInfo');
    this.$notification('Offer image updated successfully');

    this.uploadImageLoading = false;
  }

  handleClickAddImage() {
    segmentIo.track('Clicked on Add Image (Ownership experience)');
  }

  handleEditOffer(index: number) {
    segmentIo.track('Clicked on Edit Offer (Ownership experience)');
    this.selectedOfferIndex = index;
    this.editOffer();
  }

  editOffer(image?: any) {
    let offer = this.offers[Number(this.selectedOfferIndex)];

    if (!offer) return;

    if (image) {
      offer = {
        ...offer,
        image
      };
    }

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'editOfferInvitation',
        hideCancelButton: true,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        code: this.code,
        offer,
        locations: this.locations,
        businessId: this.businessId,
        onSuccess: () => {
          eventBus.$emit('reloadInviteBusinessInfo');
          this.$notification('Changes saved successfully!', 'success');
        }
      }
    );
  }

  onOfferRemoved(offerRemovedId: string) {
    this.offers = this.offers.filter(item => item.id !== offerRemovedId);
  }

  mounted() {
    eventBus.$on('updateOfferImage', this.editOffer);
    eventBus.$on('inviteMerchantOfferRemoved', this.onOfferRemoved);
  }

  beforeUnmount() {
    eventBus.$off('updateOfferImage');
    eventBus.$off('inviteMerchantOfferRemoved');
  }
}
